import palette from './palette';

const form = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0,
        fontSize: '11px',
        fontWeight: 500,
        '&.Mui-error': {
          color: palette.red[200],
        },
      },
    },
  },
};
export default form;
